





















import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import Utils from '@/utils'
import Button from '@/components/Button.vue'

@Component({
  components: {
    Button,
    Chip: Utils.loadComponent('proxy/Chip'),
    Avatar: Utils.loadComponent('proxy/Avatar'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
  },
  name: 'FloatingNotificationChip',
})
export default class FloatingNotificationChip extends Vue {
  @Prop() public id!: number | string
  @Prop() public dismissable!: boolean
  @Prop({
    type: String,
    default: 'accent',
  }) public color!: string
  @Prop() public icon!: string
  @Prop() public text!: string
  @Prop() public read?: boolean

  public disabled: boolean = true
  public visible: boolean = true
  public multiline: boolean = false

  public toggleDisabled() {
    this.$emit('read')
    this.disabled = !this.disabled
    this.$nextTick(this.width)
  }

  public alert(val: boolean) {
    if (!val) {
      this.$emit('dismissed', this.id)
    }
  }

  public width() {
    if (this.$el) {
      if (this.$parent.$el.clientWidth - this.$el.clientWidth <= 8) {
        this.multiline = true
      }
    }
  }
}
